import React, { forwardRef, useEffect, useState } from 'react'
import DatePicker, { registerLocale } from "react-datepicker";
import ko from 'date-fns/locale/ko';
import { InputWrap } from 'src/reusable';
import 'react-datepicker/dist/react-datepicker.css';

const DateBox = (props) => {
  registerLocale('ko', ko);
  const { type, handleDateRange, strtDt, endDt } = {...props};
  const [dateRange, setDateRange] = React.useState([strtDt, endDt]);
  const [startDate, endDate] = dateRange;

  const CustomInput = forwardRef(({ value, onClick }, ref) => (
    <button className="custom-input" onClick={onClick} ref={ref}>
      {value}
    </button>
  ));

  useEffect(() => {
    handleDateRange(type, startDate, endDate);
  }, [dateRange]);
  
  return (
    <InputWrap size="8" prepend="시작일 - 종료일" className="pr-0 pl-0">
      <DatePicker
        locale="ko"
        calendarStartDay={1}
        selectsRange={true}
        dayClassName={(date) => {
          return date.getDay() === 6 ? 'sat' : date.getDay() === 0 ? 'sun' : ''
        }}
        startDate={startDate}
        endDate={endDate}
        onChange={(update) => {
          setDateRange(update)
        }}
        dateFormat="yyyy-MM-dd"
        peekNextMonth
        showMonthDropdown
        showYearDropdown
        dropdownMode="select"
        customInput={<CustomInput />}
      />
    </InputWrap>
  )
}

export default React.memo(DateBox)
